<template>
  <!-- -->
  <div class="category-tree-icon mini-component">
    <div class="desc">
      可选二级分类不要超过5个，否则可能会出现排版问题，因排版影响，当前功能设置的文本大小和对齐方式将失效
    </div>
    <div v-if="showList">
      <div>
        <page-button @click="toAddNew(1)">添加一级分类</page-button>
      </div>
      <div v-for="(item, idx) in categoryTree" :key="idx">
        <div class="category-level-1">
          <alone-image-setting :data="item" @click="toSetting(item, idx)">
            <template #image>
              <yq-icon :name="item.itemIcon" class="category-icon"/>
            </template>
          </alone-image-setting>
          <yq-icon name="element-ui_d-arrow-right" :rotate-z="item.showChildren? '90deg' : '0deg'" class="category-icon-arrow" @click.stop="item.showChildren = !item.showChildren"/>
        </div>
        <div v-if="item.showChildren">
          <div class="category-tree-item" v-for="(it, id) in item.children" :key="`${idx}_${id}`">
            <alone-image-setting :data="it" @click="toSetting(it, idx, id)">
              <template #image>
                <yq-icon :name="it.itemIcon" class="category-icon"/>
              </template>
            </alone-image-setting>
          </div>
        </div>
        <div>
          <page-button @click="toAddNew(2, idx)">添加分类</page-button>
        </div>
      </div>
    </div>
    <div v-else>
      <page-button @click="showList = true">返回</page-button>
      <alone-data v-model="currentData" @change="changeData" :show-background="false" :show-image="false"/>
    </div>
  </div>
</template>

<script>

import AloneImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/AloneImageSetting.vue";
import YqIcon from "@/components/YqIcon.vue";
import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData,
    YqIcon,
    AloneImageSetting
  },
  data() {
    return {
      showList: true,
      categoryTree: [],
      currentData: {},
      currentIndex1: null,
      currentIndex2: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.categoryTree = [
          {text: "分类", itemImage: "", itemColor: "", itemIcon: "", path: "", showChildren: true, children: []},
        ];
      } else {
        this.categoryTree = this.data.componentData;
      }
    },
    changeData() {
      // 更新当前数据
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.categoryTree
      });
    },
    // 显示设置
    toSetting(data, idx1, idx2) {
      this.currentIndex1 = idx1;
      this.currentIndex2 = idx2;
      this.currentData = data;
      this.showList = false;
    },
    // 添加一个新的分类
    toAddNew(level, idx) {
      let data = {text: "分类", itemImage: "", itemColor: "", itemIcon: "", path: "",};
      if (level === 1) {
        data.showChildren = true;
        data.children = [];
        this.categoryTree.push(data);
      } else if (level === 2) {
        this.categoryTree[idx].children.push(data);
      }
      this.currentData = data;
      this.showList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.category-tree-icon{
  .category-level-1{
    position: relative;
    .category-icon-arrow{
      position: absolute;
      right: 20px;
      top: 10px;
    }
  }
  .category-icon{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 40px;
    border: 1px solid var(--yq-border-color);
  }
  .category-tree-item{
    padding-left: 20px;
  }
  :deep(.alone-image-setting) {
    .image{
      width: 60px;
    }
  }
}
</style>